
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Alert, Table, Form, Pagination, InputGroup } from "react-bootstrap";
import { fetchWithAuth } from "../utils/auth";
import { IconCaretLeft, IconSearch, IconPlus } from "@tabler/icons-react";
import { Helmet } from "react-helmet-async";

const AllProject = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedProjects, setSelectedProjects] = useState([]);
const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  const getPaginationPages = (current, total) => {
    const delta = 2;
    const pages = new Set([1, total]);
    for (let i = current - delta; i <= current + delta; i++) {
      if (i > 1 && i < total) pages.add(i);
    }
    const sorted = Array.from(pages).sort((a, b) => a - b);
    const result = [];
    for (let i = 0; i < sorted.length; i++) {
      result.push(sorted[i]);
      if (i < sorted.length - 1 && sorted[i + 1] - sorted[i] > 1) result.push("...");
    }
    return result;
  };

useEffect(() => {
  const fetchUser = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch("/api/auth/profile", {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await response.json();
      setIsAdmin(data.role === "admin");
    } catch (error) {
      console.error("Ошибка при получении профиля", error);
    }
  };
  fetchUser();
}, []);

  useEffect(() => {
    fetchProjects();
  }, [perPage, currentPage, searchQuery]);

  const fetchProjects = async () => {
    setLoading(true);
    try {
let url = `/api/admin/all-projects?limit=${perPage}&skip=${(currentPage - 1) * perPage}`;
      if (searchQuery) url += `&search=${encodeURIComponent(searchQuery)}`;
      const response = await fetchWithAuth(url);
      if (!response.ok) throw new Error("Ошибка загрузки проектов");
      const data = await response.json();
      setProjects(data.projects || []);
setTotalCount(data.total || 0);
setTotalPages(Math.ceil(data.total / perPage));
    } catch (err) {
      console.error(err);
      setError("Ошибка загрузки данных");
    } finally {
      setLoading(false);
    }
  };

  const renderBadge = (value, color) => (
    <div className={`alert alert-${color} py-1 px-2 mb-0 w-100 text-center`}>
      {value}
    </div>
  );

  const renderWithDot = (color, value) => (
    <div className="d-flex align-items-center justify-content-center gap-1">
      <span className={`badge bg-${color}`} style={{ width: 8, height: 8, borderRadius: "50%" }}></span>
      {value}
    </div>
  );
  
const handleDeleteSelected = async () => {
  if (selectedProjects.length === 0) return;

  const confirmed = window.confirm("Удалить выбранные проекты?");
  if (!confirmed) return;

  try {
    const token = localStorage.getItem("token");
    const response = await fetch("/api/projects", {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ project_ids: selectedProjects })
    });

    if (!response.ok) throw new Error("Ошибка при удалении проектов");

    setSelectedProjects([]);
    fetchProjects();
  } catch (error) {
    console.error("Ошибка при удалении:", error);
  }
};

  return (<><Helmet> <title>All Projects - IndexBooster</title></Helmet>
    <Card>
      {error && <Alert variant="danger">{error}</Alert>}
      <Card.Header className="d-flex align-items-center gap-2">
        <div className="d-flex align-items-center gap-2 flex-grow-1">
          <Button variant="light" size="sm" onClick={() => navigate(-1)}>
            <IconCaretLeft size={18} />
          </Button>
          <h3 className="card-title">All Projects (admin)</h3>
        </div>
        <div className="d-flex gap-2">
      <Button onClick={() => navigate("/indexing/add")} variant="primary" className="d-flex align-items-center gap-2 px-4 py-2" style={{ fontSize: "14px" }}>
      <IconPlus size={18} />
      Add Project
    </Button>
        </div>
      </Card.Header>

<Card.Body className="border-bottom py-3">
  <div className="d-flex justify-content-start">
    <InputGroup style={{ maxWidth: 300 }}>
      <InputGroup.Text>
        <IconSearch size={18} />
      </InputGroup.Text>
      <Form.Control
        placeholder="Search projects..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </InputGroup>
  </div>
</Card.Body>

      <div className="table-responsive">
        <Table className="table card-table table-vcenter text-nowrap datatable text-center">
          <thead>
            <tr>
            {isAdmin && <th className="w-1"><Form.Check type="checkbox" onChange={(e) =>
  setSelectedProjects(e.target.checked ? projects.map(p => p.id) : [])}
/></th>}
              <th className="text-start">Project</th>
<th>User</th>
              <th>Check Status</th>
              <th>Links</th>
              <th>Indexed %</th>
              <th>In Progress</th>
              <th>Non indexed</th>
              <th>Non indexables</th>
              <th>Creation Date</th>
              <th>Update Date</th>
            </tr>
          </thead>
<tbody>
  {loading ? (
    <tr>
      <td colSpan={isAdmin ? 9 : 8} className="text-center py-5">
        <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-2 text-muted">Loading projects...</div>
      </td>
    </tr>
  ) : projects.length === 0 ? (
    <tr><td colSpan={isAdmin ? 9 : 8} className="text-center py-4">Нет данных</td></tr>
  ) : (
    projects.map((p) => (
      <tr key={p.id}>
                                  {isAdmin && (
  <td>
    <Form.Check type="checkbox" checked={selectedProjects.includes(p.id)} onChange={(e) => {
      setSelectedProjects(prev =>
        e.target.checked
          ? [...prev, p.id]
          : prev.filter(id => id !== p.id)
      );
    }} />
  </td>
)}
                <td className="text-start"><a href={`/project/${p.id}`} className="text-reset text-primary">{p.name}</a></td>
<td>{p.user_email}</td>
                <td>{p.check_status === "In progress"
                  ? renderBadge(`In progress (${p.check_status_percent}%)`, "warning")
                  : renderBadge("Complete", "success")}</td>
                <td>{p.nb_links}</td>
                <td>{renderWithDot("green", `${p.indexed_count} (${p.indexed_percent}%)`)}</td>
                <td>{renderWithDot("yellow", `${p.in_progress_count || "-"} (${p.in_progress_percent}%)`)}</td>
                <td>{renderWithDot("red", `${p.non_indexed || "-"} (${p.non_indexed_percent}%)`)}</td>
                <td>{renderWithDot("red", `${p.non_indexables || "-"} (${p.non_indexables_percent}%)`)}</td>
                <td>
                  <div>{new Date(p.creation_date).toLocaleDateString()}</div>
                  <div>{new Date(p.creation_date).toLocaleTimeString()}</div>
                </td>
                <td>
                  <div>{new Date(p.update_date).toLocaleDateString()}</div>
                  <div>{new Date(p.update_date).toLocaleTimeString()}</div>
                </td>
      </tr>
    ))
  )}
</tbody>
        </Table>
      </div>
<Card.Footer className="px-4">
  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
    <div className="d-flex flex-column align-items-start gap-2">
      <div className="d-flex align-items-center gap-2">
        <span className="text-muted">Show</span>
        <Form.Select
          value={perPage}
          onChange={(e) => {
            setCurrentPage(1);
            setPerPage(Number(e.target.value));
          }}
          size="sm"
        >
          {[10, 25, 50, 100, 200, 500].map((val) => (
            <option key={val} value={val}>{val}</option>
          ))}
        </Form.Select>
        <span className="text-muted">entries</span>
      </div>

      {isAdmin && (
        <Button
          variant="danger"
          onClick={handleDeleteSelected}
        >
          Delete Project
        </Button>
      )}
    </div>

    <Pagination className="m-0 flex-wrap">
      <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>«</Pagination.Prev>
      {getPaginationPages(currentPage, totalPages).map((page, i) =>
        page === "..." ? (
          <Pagination.Ellipsis key={`ellipsis-${i}`} disabled />
        ) : (
          <Pagination.Item
            key={`page-${page}`}
            active={page === currentPage}
            onClick={() => setCurrentPage(page)}
          >
            {page}
          </Pagination.Item>
        )
      )}
      <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>»</Pagination.Next>
    </Pagination>
  </div>
</Card.Footer>
    </Card>
  </>);
};

export default AllProject;
